<template>
  <Modal id="add-new-template" :title="title" class="create-template-form" @submit="submit">
    <template v-slot:body>
      <div class="position-relative row general">
        <div class="col-6 col-xl-4 mt-2 mb-2" v-for="(object, key) in types" :key="key">
          <input type="radio" :value="key" v-model="type" />
          <div :class="['card', 'modal-item', key]">
            <img :src="`/assets/images/${object.logo}`" />
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  data() {
    return {
      type: ''
    }
  },
  computed: {
    title() {
      return 'Create Template'
    },
    action() {
      return 'create'
    },
    submitUri() {
      return `template/create`
    },
    data() {
      return {
        type: this.type
      }
    },
    types() {
      return Object.assign({}, this.$util.options?.template?.types)
    }
  },
  created() {
    this.store.commit('', {})
  },
  methods: {
    submit() {
      if (this.type != '') {
        this.submitForm(this.data, {
          done: (response) => {
            if (!_.isUndefined(response.id)) {
              this.$emitter.emit('Modal', {
                name: 'template.edit',
                data: {
                  _id: response.id,
                  _type: this.type
                },
                $el: this.$el
              })
            }
          }
        })
      }
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
#add-new-template.modal {
  .modal-body {
    .modal-item {
      border: 3px solid transparent;
      height: 100%;
      justify-content: center;
    }
    input[type='radio'] {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      width: 100%;
      height: 100%;
      z-index: 10;
      cursor: pointer;
      &:checked ~ div {
        border: 3px solid #00a6ff;
      }
    }
  }
}
</style>
